module.exports = __webpack_public_path__ + "media/blue-circle.e52cdbca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/en/images/standard/blue-circle.svg
// module id = 897
// module chunks = 0